import React from 'react';
import styled from 'styled-components';

import { toRem } from '@front/common/src/utils/styles';
import { ProChoice } from '@front/common/src/types/customer';
import { isWanted } from '@front/common/src/utils/previous-pros';

import { getBasketText, getBasketTitle } from '@front/customer/src/utils/previous-pros';

import { translate } from '@front/i18n';

import Text from '@front/web-ui/src/components/base-text/variants/text';
import Accordion from '@front/web-ui/src/components/accordion/accordion';
import Separator from '@front/web-ui/src/components/separator/separator';

import { PREVIOUS_PROS_PATH, route } from '../../steps/steps';
import useBasketSection from '../../hooks/use-basket-section';

const t = translate('basket');

const StyledAccordion = styled(Accordion)`
  padding: ${toRem(5)} 0 ${toRem(20)};
`;

const TopSeparator = styled(Separator)`
  margin-bottom: ${toRem(15)};
`;

type ProChoicesProps = {
  proChoices: ProChoice[];
  hasTopSeparator?: boolean;
  hasBottomSeparator?: boolean;
};

const ProChoices = ({ proChoices, hasTopSeparator = false, hasBottomSeparator = true }: ProChoicesProps) => {
  const wantedChoices = proChoices.filter(isWanted);
  const { isOpen, hasData } = useBasketSection({
    data: wantedChoices.length > 0,
    sectionLocations: [route(PREVIOUS_PROS_PATH)],
  });

  if (!hasData) return null;

  return (
    <>
      {hasTopSeparator && <TopSeparator />}
      <StyledAccordion
        icon='person-filled'
        iconLabel={t('.previous_pros.icon_label')}
        title={getBasketTitle(wantedChoices)}
        isOpen={isOpen}
      >
        <Text>{getBasketText(wantedChoices)}</Text>
      </StyledAccordion>
      {hasBottomSeparator && <Separator />}
    </>
  );
};

export default ProChoices;
